import i18n from '@src/i18n'

export default {
  /**
   * Value of a table cell to sort on: numbers (amounts) as numbers, the
   * rest lowercased; empty cells first.
   */
  sortValue: function (value) {
    if (value === null || value === undefined) return ''
    return typeof value === 'number' ? value : String(value).toLowerCase()
  },
  /**
   * Normalizes a string for search comparison.
   *
   * - Lowercases the string
   * - Replaces ligatures (œ → oe, æ → ae)
   * - Strips diacritics/accents via Unicode NFD decomposition (é → e, ü → u, etc.)
   * - Replaces hyphens and underscores with spaces (Saint-Nicolas → saint nicolas)
   * - Trims leading/trailing whitespace
   *
   * @param {string} str
   * @returns {string}
   */
  normalizeSearch: function (str) {
    if (str === null || str === undefined || str === '') return ''
    return String(str)
      .toLowerCase()
      .replace(/œ/g, 'oe')
      .replace(/æ/g, 'ae')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[-_]/g, ' ')
      .trim()
  },

  searchInlist: function (copyModelList, attributes, searchTerms) {
    return copyModelList.filter((model) => {
      let search = this.normalizeSearch(searchTerms)

      let flag = false
      attributes.forEach((val) => {
        let resp = val.field.split('.').reduce((o, i) => o[i], model)
        if (Array.isArray(resp) || typeof resp === 'object') {
          resp = resp?.[i18n.global.locale] ?? ''
        }
        switch (val.type) {
          case 'string': {
            if (resp && this.normalizeSearch(resp).includes(search)) {
              flag = true
              return
            }
            break
          }
        }
      })
      if (flag) {
        return model
      }
    })
  }
}
